export default __webpack_public_path__ + "static/media/user-journey-img4.7e3f12a0.svg";